/* Exokit — configurateur d'aménagement v3
   Données : métaobjets Shopify (Véhicule, Aménagement, Zone, Option) rendus en JSON par la section.
   Options produit : lues en direct dans Globo Product Options (window.GPOConfigs), panier au format Globo. */
(function () {
  var SWATCH = { 'contreplaqué brut': '#E6D2AC', 'brut': '#E6D2AC', 'soupçon de blanc': '#EEE7DA', 'chêne clair': '#D7B887', 'chêne doré': '#C2964F', 'gris béton': '#9E9C96', 'gris flamant': '#B4ADA2', 'gris flamand': '#B4ADA2', 'ébène': '#3A2F2C', 'chêne vicenza': '#C9A372', 'vert fjord': '#4E6A5C', 'blanc uni': '#F6F6F2' };
  var DARK = ['#3A2F2C', '#4E6A5C', '#9E9C96'];
  var CUSH = { 'gris clair': '#C9CCCB', 'anthracite': '#4A4D50', 'gris foncé': '#4A4D50', 'chiné': '#8B8E90', 'beige': '#D9C8A9', 'bleu': '#3E5C7A' };
  var TEAL = '#004F5D';
  var SEAT = '#CFE0EA', SEAT_D = '#7E9CAD'; /* banquettes et couchages : assise bleu-gris, distincte du bois des meubles */
  var GPO_TYPES = ['image-swatches', 'buttons', 'radio', 'checkbox', 'select', 'dropdown', 'color-swatches'];

  function colorIn(map, title, fallback) { var t = (title || '').toLowerCase(); for (var k in map) { if (t.indexOf(k) !== -1) return map[k]; } return fallback; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function familyOf(title) { var t = (title || '').toLowerCase(); if (t.indexOf('huil') !== -1) return 'Huilé'; if (t.indexOf('strat') !== -1) return 'Stratifié'; return 'Brut'; }
  function finishLabel(title) { var m = (title || '').match(/^(.*?)\s*["“«]\s*(.+?)\s*["”»]\s*$/); return m ? { family: m[1].trim(), tint: m[2].trim() } : { family: title || '', tint: '' }; }
  function shortFinish(title) { var f = finishLabel(title); return f.tint ? f.family + ' ' + f.tint : f.family; }
  function parsePlan(text) {
    return String(text || '').split(/[\n;]+/).map(function (line) {
      var p = line.split(','); var n = p.slice(0, 4).map(function (v) { return parseFloat(v); });
      if (n.length < 4 || n.some(isNaN)) return null;
      return { x: n[0], y: n[1], w: n[2], h: n[3], label: (p[4] || '').trim(), style: (p[5] || 'meuble').trim().toLowerCase() };
    }).filter(Boolean);
  }

  /* ---------- Globo Product Options ---------- */
  var gpoCache = {}, GPO_SETS = {}; /* jeux d'options Globo fournis par la section (métachamps globo_option.*) */
  function gpoFor(product) {
    if (!product) return null;
    if (gpoCache[product.id] !== undefined) return gpoCache[product.id];
    var G = window.GPOConfigs, found = null;
    var check = function (o, k) {
      if (!o || found) return;
      try {
        var r = o.products && o.products.rule;
        if (r && r.manual && r.manual.enable && (r.manual.ids || []).map(Number).indexOf(Number(product.id)) !== -1) found = { id: String(k || o.id), o: o };
      } catch (e) { /* ignore */ }
    };
    Object.keys(GPO_SETS).forEach(function (k) { check(GPO_SETS[k], k); });
    if (!found && G && G.options) {
      if (Array.isArray(G.options)) G.options.forEach(function (o, i) { check(o, o && o.id ? o.id : i); }); else Object.keys(G.options).forEach(function (k) { check(G.options[k], k); });
    }
    var res = null;
    if (found) {
      var els = [];
      (function walk(list) { (list || []).forEach(function (e) { if (e && e.type === 'group') walk(e.elements); else if (e) els.push(e); }); })(found.o.elements);
      els = els.filter(function (e) {
        var vals = e.option_values || [];
        if (GPO_TYPES.indexOf(e.type) === -1 || !vals.length) return false;
        return !vals.some(function (v) { return /^coussins-/.test(v.product_handle || ''); }); /* les coussins sont gérés par le configurateur */
      }).map(function (e) {
        var label = String(e.label_fr || e.label || e.id).trim();
        return {
          id: e.id, type: e.type, label: label, cart: String(e.label_on_cart || e.label || e.id).trim(), required: !!e.required,
          def: (e.default_value || [])[0],
          values: e.option_values.map(function (v) { return { value: v.value_fr || v.value, price: v.variant_id ? Math.round(parseFloat(v.variant_price || '0') * 100) : 0, variant: v.variant_id || null }; })
        };
      });
      if (els.length) res = { setId: found.id, elements: els };
    }
    gpoCache[product.id] = res;
    return res;
  }

  function init(root) {
    if (root.getAttribute('data-exo-ready')) return;
    root.setAttribute('data-exo-ready', '1');
    var cfg = JSON.parse(root.querySelector('[data-cfg]').textContent);
    var uid = root.id, V = cfg.vehicle;
    if (cfg.gpo) Object.keys(cfg.gpo).forEach(function (k) { GPO_SETS[k] = cfg.gpo[k]; });

    function money(cents) {
      var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}}€';
      var parts = (cents / 100).toFixed(2).split('.');
      var comma = fmt.indexOf('comma') !== -1;
      var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      if (fmt.indexOf('amount_no_decimals') !== -1) return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, ip);
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, ip + (comma ? ',' : '.') + parts[1]);
    }
    function moneyShort(cents) { return money(cents).replace(/[,.]00(?=\D*$)/, ''); }

    /* ----- données ----- */
    var zones = cfg.zones.filter(function (z) { return z.options && z.options.length; });
    var byKey = {}, zoneOf = {};
    zones.forEach(function (z, i) {
      z.idx = i;
      z.options.forEach(function (m) {
        m.zone = z.id; m.dayList = parsePlan(m.day); m.nightList = parsePlan(m.night);
        m.soon = !m.product; m.extern = m.extern || ''; m.suggestList = parsePlan(m.suggestPlan); m.excludes = m.excludes || [];
        byKey[m.key] = m; zoneOf[m.key] = z;
      });
    });
    Object.keys(byKey).forEach(function (k) {
      var m = byKey[k];
      m.excludes.forEach(function (x) { var o = byKey[x]; if (o && o.excludes.indexOf(m.key) === -1) o.excludes.push(m.key); if (o && !o.reason && m.reason) o.reason = m.reason; });
    });
    var habs = (cfg.habillages || []).filter(function (h) { return h.product; });

    var state = { sel: {}, fin: {}, hab: {}, gpo: {}, cush: {}, notice: {}, lastFin: null, mode: 'jour' };
    zones.forEach(function (z) {
      var d = z.options.filter(function (m) { return m.isDefault; })[0] || (z.none ? null : z.options.filter(function (m) { return !m.soon; })[0] || z.options[0]);
      state.sel[z.id] = d ? d.key : null;
    });

    function selected() { return zones.map(function (z) { return byKey[state.sel[z.id]]; }).filter(Boolean); }
    function selectedHabs() { return habs.filter(function (h) { return state.hab[h.key]; }); }
    function blockerOf(m) { var s = selected(); for (var i = 0; i < s.length; i++) { if (zoneOf[s[i].key].idx < zoneOf[m.key].idx && s[i].excludes.indexOf(m.key) !== -1) return s[i]; } return null; }
    function suggestionOf(m) { /* option suggérée en pointillé : seulement si elle existe, n'est pas déjà choisie et reste compatible */
      var t = m && m.suggest && byKey[m.suggest];
      if (!t || t.key === m.key || state.sel[zoneOf[t.key].id] === t.key || blockerOf(t)) return null;
      return t;
    }
    function hasFinish(m, title) { return !!m.product && m.product.variants.some(function (v) { return v.title === title; }); }
    function finOf(m) { if (!m.product) return ''; var f = state.fin[m.key]; return f && hasFinish(m, f) ? f : m.product.variants[0].title; }
    function variantFor(m) { if (!m.product) return null; var f = finOf(m); return m.product.variants.filter(function (v) { return v.title === f; })[0] || m.product.variants[0]; }
    function imgFor(m) { var v = variantFor(m); return (v && v.img) || (m.product && m.product.image) || null; }
    function multi(m) { return !!m.product && m.product.variants.length > 1; }
    function hasNight() { return selected().some(function (m) { return m.nightList.length; }); }

    /* ----- Globo : sélection et prix ----- */
    function gpoState(product) {
      var g = gpoFor(product); if (!g) return null;
      var st = state.gpo[product.id];
      if (!st) {
        st = state.gpo[product.id] = {};
        g.elements.forEach(function (e) {
          var i = -1;
          if (e.def != null) e.values.forEach(function (v, j) { if (v.value === e.def) i = j; });
          if (i === -1 && e.type !== 'checkbox' && e.required) i = 0;
          if (i !== -1) st[e.id] = i;
        });
      }
      return { g: g, st: st };
    }
    function gpoExtra(product) {
      var s = gpoState(product); if (!s) return 0;
      return s.g.elements.reduce(function (sum, e) { var i = s.st[e.id]; return sum + (i != null ? e.values[i].price : 0); }, 0);
    }
    function gpoSummary(product) {
      var s = gpoState(product); if (!s) return '';
      return s.g.elements.map(function (e) { var i = s.st[e.id]; return i != null ? e.label + ' : ' + e.values[i].value : ''; }).filter(Boolean).join(' · ');
    }
    function gpoMissing(product, name) {
      var s = gpoState(product); if (!s) return [];
      return s.g.elements.filter(function (e) { return e.required && s.st[e.id] == null; }).map(function (e) { return e.label + ' (' + name + ')'; });
    }
    function gpoPanel(product, name) {
      var s = gpoState(product); if (!s) return '';
      var html = '';
      s.g.elements.forEach(function (e) {
        var isFin = /finition|teinte/i.test(e.label);
        html += '<div class="exo-am__gpo"><div class="exo-am__gpo-label">' + esc(e.label) + (e.required && s.st[e.id] == null ? ' <em>à préciser</em>' : '') + '</div><div class="exo-am__gpo-vals">';
        e.values.forEach(function (v, i) {
          html += '<button type="button" class="exo-am__chip' + (isFin ? '' : ' exo-am__chip--plain') + '" data-gpo-pid="' + product.id + '" data-gpo-el="' + esc(e.id) + '" data-gpo-i="' + i + '" aria-pressed="' + (s.st[e.id] === i) + '">' +
            (isFin ? '<i style="background:' + colorIn(SWATCH, v.value, '#E6D2AC') + '"></i>' : '') + esc(v.value) + (v.price ? ' <small>+' + moneyShort(v.price) + '</small>' : '') + '</button>';
        });
        html += '</div></div>';
      });
      return html ? '<div class="exo-am__fin exo-am__fin--gpo"><div class="exo-am__fin-head"><strong>Options · ' + esc(name) + '</strong></div>' + html + '</div>' : '';
    }

    function itemPrice(m) { var v = variantFor(m); return v ? v.price + gpoExtra(m.product) : 0; }
    function habPrice(h) { return h.product.variants[0].price + gpoExtra(h.product); }

    (function () {
      var total = 0;
      zones.forEach(function (z) { var m = byKey[state.sel[z.id]]; if (m && m.product) total += m.product.variants[0].price; });
      var el = root.querySelector('[data-from]'); if (el && total) el.textContent = money(total);
    })();

    function choose(zoneId, key) {
      state.notice = {};
      state.sel[zoneId] = key;
      var m = byKey[key];
      if (m) {
        if (!state.fin[m.key] && state.lastFin && hasFinish(m, state.lastFin)) state.fin[m.key] = state.lastFin;
        zones.forEach(function (z) {
          var other = byKey[state.sel[z.id]];
          if (!other || other.key === m.key || m.excludes.indexOf(other.key) === -1) return;
          var repl = z.options.filter(function (x) { return x.key !== other.key && !x.soon && m.excludes.indexOf(x.key) === -1; })[0];
          state.sel[z.id] = repl ? repl.key : null;
          state.notice[z.id] = repl
            ? other.name + ' est remplacé par ' + repl.name + ' : ' + (m.reason || 'incompatible avec ' + m.name + '.')
            : other.name + ' a été retiré : ' + (m.reason || 'incompatible avec ' + m.name + '.');
        });
      }
      render();
    }

    /* ----- étapes ----- */
    var stepsEl = root.querySelector('[data-steps]');
    function stepHead(n, label, sub) {
      return '<h2 class="exo-am__step-title"><span class="exo-am__num">' + n + '</span> ' + esc(label) + '</h2>' + (sub ? '<p class="exo-am__step-sub">' + esc(sub) + '</p>' : '');
    }
    function galBtn(gk, name) {
      var p = gallerySrc(gk); if (!p) return '';
      var n = (p.gallery || []).length;
      return '<button type="button" class="exo-am__zoom" data-gal="' + esc(gk) + '" aria-label="' + esc('Voir les photos : ' + name) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M21 17l-5-5-8 7"/></svg>' + (n > 1 ? n + ' photos' : 'Photo') + '</button>';
    }
    function card(attrs, pressed, disabled, img, name, sub, price, extraClass, badge, gk) {
      var z = gk ? galBtn(gk, name) : '';
      return (z ? '<div class="exo-am__optwrap">' : '') + '<button type="button" class="exo-am__opt' + (extraClass || '') + '" ' + attrs + ' aria-pressed="' + pressed + '"' + (disabled ? ' disabled' : '') + '>' +
        '<span class="exo-am__opt-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="320" height="240">' : '') + (badge ? '<span class="exo-am__badge">' + esc(badge) + '</span>' : '') + '</span>' +
        '<span class="exo-am__opt-body"><span class="exo-am__opt-name">' + esc(name) + '</span>' +
        (sub ? '<span class="exo-am__opt-sub">' + esc(sub) + '</span>' : '') +
        '<span class="exo-am__opt-price">' + price + '</span></span></button>' + (z ? z + '</div>' : '');
    }
    function finishPanel(m) {
      var cur = finOf(m), fams = {}, order = [];
      m.product.variants.forEach(function (v) { var k = familyOf(v.title); if (!fams[k]) { fams[k] = []; order.push(k); } fams[k].push(v); });
      var base = m.product.variants[0].price;
      var html = '<div class="exo-am__fin" role="group" aria-label="' + esc((cfg.finishLabel || 'Finition') + ' — ' + m.name) + '">' +
        '<div class="exo-am__fin-head"><strong>' + esc(cfg.finishLabel || 'Finition') + ' · ' + esc(m.name) + '</strong><span>' + esc(shortFinish(cur)) + ' · ' + money(variantFor(m).price) + '</span></div>';
      order.forEach(function (k) {
        var d = fams[k][0].price - base;
        html += '<div class="exo-am__fam"><div class="exo-am__fam-head"><span>' + esc(k) + (fams[k].length > 1 ? ' · ' + fams[k].length + ' teintes' : '') + '</span><span>' + (d > 0 ? '+' + moneyShort(d) : 'prix de base') + '</span></div><div class="exo-am__sws">';
        fams[k].forEach(function (v) {
          html += '<button type="button" class="exo-am__sw" data-fin-key="' + esc(m.key) + '" data-fin="' + esc(v.title) + '" aria-pressed="' + (v.title === cur) + '" aria-label="' + esc(v.title + ' — ' + money(v.price)) + '" title="' + esc(shortFinish(v.title)) + '" style="background:' + colorIn(SWATCH, v.title, '#E6D2AC') + '"></button>';
        });
        html += '</div></div>';
      });
      var others = selected().filter(function (o) { return o.key !== m.key && multi(o) && hasFinish(o, cur) && finOf(o) !== cur; });
      if (others.length) html += '<button type="button" class="exo-am__apply" data-apply="' + esc(cur) + '">Appliquer « ' + esc(shortFinish(cur)) + ' » aux autres meubles</button>';
      if (cfg.samplesUrl) html += '<a class="exo-am__samples" href="' + esc(cfg.samplesUrl) + '">Commander des échantillons</a>';
      return html + '</div>';
    }
    function cap(t) { t = String(t || ''); return t.charAt(0).toUpperCase() + t.slice(1); }
    function blockedSub(m, b) {
      var z = zoneOf[m.key], all = z.options.every(function (x) { return b.excludes.indexOf(x.key) !== -1; });
      if (all && b.reason) return cap(b.reason); /* toute la zone est retirée : on donne la raison du choix bloquant */
      return m.blockedText || m.reason || (b.reason ? cap(b.reason) : 'Incompatible avec ' + b.name);
    }
    function cushionCandidates() { return selected().filter(function (m) { return m.cushion || m.hasCushionRef; }); }

    function renderSteps() {
      var html = '', n = 0;
      zones.forEach(function (z) {
        n++;
        html += '<div class="exo-am__step">' + stepHead(n, z.title, z.sub);
        if (z.info) html += '<div class="exo-am__info" style="display:flex;gap:12px;align-items:flex-start;margin:4px 0 14px 38px;padding:12px 14px;border-radius:10px;background:#E7F1F2;color:#004F5D;font-size:13px;line-height:1.45">' + (z.infoImg ? '<img src="' + esc(z.infoImg) + '" alt="" loading="lazy" style="width:120px;height:auto;border-radius:6px;flex:0 0 auto">' : '') + '<div><p style="margin:0 0 6px">' + esc(z.info) + '</p><a href="' + esc(cfg.contactUrl) + '" style="color:#004F5D;font-weight:600">Un doute ? Nous demander confirmation</a></div></div>';
        if (state.notice[z.id]) html += '<p class="exo-am__notice" role="status">' + esc(state.notice[z.id]) + '</p>';
        html += '<div class="exo-am__opts">';
        z.options.forEach(function (m) {
          var b = blockerOf(m), on = state.sel[z.id] === m.key;
          var price, sub = b ? blockedSub(m, b) : m.desc;
          if (m.soon) price = '<span class="exo-am__soon">' + esc(m.extern || 'Bientôt disponible') + '</span>';
          else price = (multi(m) && !on ? 'dès ' : '') + money(on ? itemPrice(m) : m.product.variants[0].price);
          html += card('data-zone="' + esc(z.id) + '" data-key="' + esc(m.key) + '"', on, !!b, on ? imgFor(m) : (m.product && (m.product.variants[0].img || m.product.image)), m.name, sub, price, m.soon ? ' exo-am__opt--soon' : '', m.soon ? (m.extern ? 'Compatible' : 'Bientôt') : (m.couchage ? 'Lit ' + m.couchage : ''), m.product ? 'o:' + m.key : '');
        });
        if (z.none) html += card('data-zone="' + esc(z.id) + '" data-key=""', state.sel[z.id] === null, false, null, z.none, '', '—', ' exo-am__opt--none');
        html += '</div>';
        var cur = byKey[state.sel[z.id]];
        if (cur && cur.soon) html += cur.extern
          ? '<p class="exo-am__notice exo-am__notice--soon">' + esc(cur.name) + ' : ' + esc(cur.extern) + '. Elle apparaît sur le plan mais n\'est pas ajoutée au panier. <a href="' + esc(cfg.contactUrl) + '">Nous demander conseil</a></p>'
          : '<p class="exo-am__notice exo-am__notice--soon">' + esc(cur.name) + ' arrive bientôt : il apparaît sur le plan mais ne sera pas ajouté au panier. <a href="' + esc(cfg.contactUrl) + '">Être prévenu ou demander un devis</a></p>';
        if (cur && cur.warn) html += '<div class="exo-am__notice exo-am__notice--warn" role="note" style="display:flex;gap:10px;align-items:flex-start">' + (cur.warnImg ? '<img src="' + esc(cur.warnImg) + '" alt="" loading="lazy" style="width:110px;height:auto;border-radius:6px;flex:0 0 auto">' : '') + '<span><strong>⚠ Attention :</strong> ' + esc(cur.warn) + ' <a href="' + esc(cfg.contactUrl) + '">Nous demander conseil</a></span></div>';
        var sg = suggestionOf(cur);
        if (sg) html += '<p class="exo-am__notice exo-am__notice--suggest" style="background:#E7F1F2;color:#004F5D">' + esc(cur.suggestText || ('Possible avec votre choix : ' + sg.name + '.')) + ' <button type="button" class="exo-am__suggest-btn" style="margin-left:6px;padding:3px 10px;border:1px solid #004F5D;border-radius:999px;background:#fff;color:#004F5D;font:inherit;font-size:12px;font-weight:600;cursor:pointer" data-zone="' + esc(zoneOf[sg.key].id) + '" data-key="' + esc(sg.key) + '">Choisir ' + esc(sg.name) + '</button></p>';
        if (cur && multi(cur)) html += finishPanel(cur);
        if (cur && cur.product) html += gpoPanel(cur.product, cur.name);
        html += '</div>';
      });

      var cands = cushionCandidates();
      if (cands.length) {
        n++;
        html += '<div class="exo-am__step">' + stepHead(n, cfg.cushionLabel || 'Coussins', cfg.cushionSub);
        cands.forEach(function (m) {
          html += '<div class="exo-am__cush"><p class="exo-am__cush-title">' + esc(m.name) + (m.cushion ? ' <span>' + money(m.cushion.variants[0].price) + '</span>' : '') + '</p>';
          if (!m.cushion) {
            html += '<p class="exo-am__step-sub exo-am__step-sub--flat">Coussins bientôt disponibles pour cette banquette. <a href="' + esc(cfg.contactUrl) + '">Nous consulter</a></p>';
          } else {
            html += '<div class="exo-am__chips">';
            m.cushion.variants.forEach(function (v) {
              html += '<button type="button" class="exo-am__chip" data-cush-key="' + esc(m.key) + '" data-cush="' + v.id + '" aria-pressed="' + (state.cush[m.key] === v.id) + '"><i style="background:' + colorIn(CUSH, v.title, '#C9CCCB') + '"></i>' + esc(v.title.replace(/^(tissus?|coussins?)\s+/i, '')) + '</button>';
            });
            html += '<button type="button" class="exo-am__chip exo-am__chip--plain" data-cush-key="' + esc(m.key) + '" data-cush="none" aria-pressed="' + (state.cush[m.key] === 'none') + '">Sans coussins</button></div>';
          }
          html += '</div>';
        });
        html += '</div>';
      }

      if (habs.length && !cfg.hideHab) {
        n++;
        var allOn = habs.every(function (h) { return state.hab[h.key]; });
        html += '<div class="exo-am__step">' + stepHead(n, cfg.habillageLabel, cfg.habillageSub);
        if (habs.length > 1) html += '<div class="exo-am__hab-all"><button type="button" class="exo-am__chip exo-am__chip--plain" data-hab-all aria-pressed="' + allOn + '">' + (allOn ? '✓ ' : '') + 'Habillage complet · ' + money(habs.reduce(function (s, h) { return s + h.product.variants[0].price; }, 0)) + '</button></div>';
        html += '<div class="exo-am__opts">';
        habs.forEach(function (h) {
          var on = !!state.hab[h.key];
          html += card('data-hab="' + esc(h.key) + '"', on, false, h.product.variants[0].img || h.product.image, h.name, h.desc, (on ? '✓ ' + money(habPrice(h)) : '+ ' + money(h.product.variants[0].price)), ' exo-am__opt--toggle', 'h:' + h.key);
        });
        html += '</div>';
        selectedHabs().forEach(function (h) { html += gpoPanel(h.product, h.name); });
        html += '</div>';
      }
      stepsEl.innerHTML = html;
    }

    stepsEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || b.disabled) return;
      if (b.hasAttribute('data-gal')) { openGallery(b.getAttribute('data-gal'), b); return; }
      if (b.hasAttribute('data-zone')) choose(b.getAttribute('data-zone'), b.getAttribute('data-key') || null);
      else if (b.hasAttribute('data-fin')) { var k = b.getAttribute('data-fin-key'), f = b.getAttribute('data-fin'); state.fin[k] = f; state.lastFin = f; render(); }
      else if (b.hasAttribute('data-apply')) { var t = b.getAttribute('data-apply'); selected().forEach(function (m) { if (hasFinish(m, t)) state.fin[m.key] = t; }); state.lastFin = t; render(); }
      else if (b.hasAttribute('data-hab')) { var hk = b.getAttribute('data-hab'); state.hab[hk] = !state.hab[hk]; render(); }
      else if (b.hasAttribute('data-hab-all')) { var on = !habs.every(function (h) { return state.hab[h.key]; }); habs.forEach(function (h) { state.hab[h.key] = on; }); render(); }
      else if (b.hasAttribute('data-cush')) { var ck = b.getAttribute('data-cush-key'), cv = b.getAttribute('data-cush'); state.cush[ck] = cv === 'none' ? 'none' : parseInt(cv, 10); render(); }
      else if (b.hasAttribute('data-gpo-pid')) {
        var pid = b.getAttribute('data-gpo-pid'), el = b.getAttribute('data-gpo-el'), i = parseInt(b.getAttribute('data-gpo-i'), 10);
        var st = state.gpo[pid]; if (st) { st[el] = (st[el] === i && !isRequired(pid, el)) ? null : i; }
        render();
      }
    });
    function isRequired(pid, elId) {
      var all = selected().map(function (m) { return m.product; }).concat(habs.map(function (h) { return h.product; })).filter(Boolean);
      var p = all.filter(function (x) { return String(x.id) === String(pid); })[0]; var g = p && gpoFor(p);
      return !!(g && g.elements.some(function (e) { return e.id === elId && e.required; }));
    }

    /* ----- galerie photo du produit (fenêtre) ----- */
    function gallerySrc(gk) {
      if (!gk) return null;
      if (gk.indexOf('o:') === 0) { var m = byKey[gk.slice(2)]; return m && m.product; }
      if (gk.indexOf('h:') === 0) { var h = habs.filter(function (x) { return x.key === gk.slice(2); })[0]; return h && h.product; }
      return null;
    }
    var dlg = null, gal = { list: [], i: 0, opener: null };
    function galDialog() {
      if (dlg) return dlg;
      dlg = document.createElement('dialog');
      dlg.className = 'exo-am__gal';
      dlg.setAttribute('aria-labelledby', uid + '-gal-t');
      dlg.innerHTML = '<div class="exo-am__gal-box"><div class="exo-am__gal-head"><h3 id="' + uid + '-gal-t" data-gal-title></h3><button type="button" class="exo-am__gal-x" data-gal-close aria-label="Fermer">×</button></div>' +
        '<div class="exo-am__gal-stage"><button type="button" class="exo-am__gal-nav exo-am__gal-nav--p" data-gal-prev aria-label="Photo précédente">‹</button><img data-gal-img alt=""><button type="button" class="exo-am__gal-nav exo-am__gal-nav--n" data-gal-next aria-label="Photo suivante">›</button><span class="exo-am__gal-count" data-gal-count></span></div>' +
        '<div class="exo-am__gal-thumbs" data-gal-thumbs></div><p class="exo-am__gal-about" data-gal-about></p>' +
        '<div class="exo-am__gal-foot"><a data-gal-link target="_blank" rel="noopener">Voir la fiche produit complète ↗</a><span>S\'ouvre dans un nouvel onglet : votre configuration reste ici.</span></div></div>';
      root.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-gal-close]')) return dlg.close();
        if (e.target.closest('[data-gal-prev]')) return galShow(gal.i - 1);
        if (e.target.closest('[data-gal-next]')) return galShow(gal.i + 1);
        var t = e.target.closest('[data-gal-i]'); if (t) galShow(parseInt(t.getAttribute('data-gal-i'), 10));
      });
      dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') galShow(gal.i - 1); else if (e.key === 'ArrowRight') galShow(gal.i + 1); });
      dlg.addEventListener('close', function () { if (gal.opener && document.contains(gal.opener)) gal.opener.focus(); });
      return dlg;
    }
    function galShow(i) {
      var n = gal.list.length; if (!n) return;
      gal.i = (i + n) % n;
      var img = dlg.querySelector('[data-gal-img]'); img.src = gal.list[gal.i];
      dlg.querySelector('[data-gal-count]').textContent = n > 1 ? (gal.i + 1) + ' / ' + n : '';
      dlg.querySelectorAll('[data-gal-i]').forEach(function (t, j) { t.setAttribute('aria-current', String(j === gal.i)); });
    }
    function openGallery(gk, opener) {
      var p = gallerySrc(gk); if (!p) return;
      var m = gk.indexOf('o:') === 0 ? byKey[gk.slice(2)] : null;
      var first = m ? imgFor(m) : null, list = (p.gallery || []).slice();
      if (!list.length && p.image) list.push(p.image);
      if (first) { var base = first.split('?')[0].replace(/_\d+x\d*(?=\.\w+$)/, ''); var j = -1; list.forEach(function (u, k) { if (j === -1 && u.split('?')[0].replace(/_\d+x\d*(?=\.\w+$)/, '') === base) j = k; }); if (j > 0) { var u = list.splice(j, 1)[0]; list.unshift(u); } }
      var d = galDialog();
      gal.list = list; gal.opener = opener;
      d.querySelector('[data-gal-title]').textContent = m ? m.name : p.title;
      d.querySelector('[data-gal-img]').alt = p.title;
      d.querySelector('[data-gal-about]').textContent = p.about || '';
      d.querySelector('[data-gal-link]').href = p.url;
      d.querySelector('[data-gal-thumbs]').innerHTML = list.length > 1 ? list.map(function (u, k) { return '<button type="button" data-gal-i="' + k + '" aria-label="Photo ' + (k + 1) + '"><img src="' + esc(u.replace('width=1200', 'width=160')) + '" alt="" loading="lazy"></button>'; }).join('') : '';
      d.querySelectorAll('[data-gal-prev],[data-gal-next]').forEach(function (x) { x.hidden = list.length < 2; });
      galShow(0);
      if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    }

    /* ----- plan ----- */
    var planEl = root.querySelector('[data-plan]'), legendEl = root.querySelector('[data-legend]'), modeEl = root.querySelector('[data-mode]');
    function habOn(kind) { return selectedHabs().some(function (h) { return h.key === kind; }); }
    function cushColor(m) { var c = state.cush[m.key]; if (!m.cushion || typeof c !== 'number') return null; var v = m.cushion.variants.filter(function (x) { return x.id === c; })[0]; return v ? colorIn(CUSH, v.title, '#C9CCCB') : null; }
    function rect(x, y, w, h, rx, fill, extra) { return '<rect x="' + x + '" y="' + y + '" width="' + Math.max(0, w) + '" height="' + Math.max(0, h) + '" rx="' + rx + '" fill="' + fill + '"' + (extra || '') + '/>'; }
    function shape(m, r, ox, oy, fill, cush, soon) {
      var x = ox + r.x, y = oy + r.y, w = r.w, h = r.h, s = '', st = r.style;
      var stroke = ' stroke="' + TEAL + '" stroke-width="1.4"' + (soon ? ' stroke-dasharray="4 3"' : '');
      var title = '<title>' + esc(m.name + (m.product ? ' · ' + shortFinish(finOf(m)) : ' · ' + (m.extern || 'bientôt disponible'))) + '</title>';
      var f = soon ? '#F4F1EA' : fill;
      if (st === 'table') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="#fff" stroke="' + TEAL + '" stroke-width="1.2" stroke-dasharray="3 2">' + title + '</rect>';
      } else if (st === 'plan') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        s += rect(x + 2, y + 2, w - 4, h - 4, 6, soon ? '#F4F1EA' : '#EADCBF', ' stroke="#BFA77C" stroke-width=".8"');
      } else if (st === 'assise' || st === 'dossier') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + (st === 'dossier' ? (cush || SEAT_D) : f) + '"' + stroke + '>' + title + '</rect>';
        if (st === 'assise') s += rect(x + 3, y + 3, w - 6, h - 6, 5, cush || SEAT, ' opacity=".95"');
      } else if (st === 'couchage') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        s += rect(x + 3, y + 3, w - 6, h - 6, 7, cush || SEAT, ' opacity=".95"');
        if (!cush) { var g = ''; var vert = w >= h; var len = vert ? w : h; for (var i = 9; i < len - 4; i += 9) g += vert ? '<line x1="' + (x + i) + '" y1="' + (y + 4) + '" x2="' + (x + i) + '" y2="' + (y + h - 4) + '"/>' : '<line x1="' + (x + 4) + '" y1="' + (y + i) + '" x2="' + (x + w - 4) + '" y2="' + (y + i) + '"/>'; s += '<g stroke="' + TEAL + '" stroke-opacity=".28" stroke-width="1">' + g + '</g>'; }
      } else if (st === 'malle') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="8" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        s += rect(x + 4, y + 4, w - 8, h - 8, 5, 'none', ' stroke="' + TEAL + '" stroke-opacity=".45" stroke-width="1"');
      } else if (st === 'frigo') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        var cx = x + w / 2, cy = y + h / 2, k = Math.min(w, h) * 0.22, col = DARK.indexOf(f) !== -1 ? '#fff' : TEAL;
        s += '<g stroke="' + col + '" stroke-width="1.4" stroke-linecap="round"><line x1="' + (cx - k) + '" y1="' + cy + '" x2="' + (cx + k) + '" y2="' + cy + '"/><line x1="' + (cx - k * .5) + '" y1="' + (cy - k * .87) + '" x2="' + (cx + k * .5) + '" y2="' + (cy + k * .87) + '"/><line x1="' + (cx - k * .5) + '" y1="' + (cy + k * .87) + '" x2="' + (cx + k * .5) + '" y2="' + (cy - k * .87) + '"/></g>';
        return s;
      } else if (st === 'colonne') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        s += rect(x, y, w, h, 2, TEAL, ' fill-opacity=".1"');
        s += rect(x + 3, y + 3, w - 6, h - 6, 2, 'none', ' stroke="' + TEAL + '" stroke-opacity=".4" stroke-width=".8"');
      } else if (st === 'cuisine') {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
        s += rect(x + 2, y + 2, w - 4, h - 4, 6, soon ? '#F4F1EA' : '#EADCBF', ' stroke="#BFA77C" stroke-width=".8"');
        var sk = Math.min(w * 0.32, 30), sh = Math.min(h * 0.55, 24), sy = y + (h - sh) / 2;
        s += rect(x + 6, sy, sk, sh, 4, '#fff', ' stroke="' + TEAL + '" stroke-width="1"');
        var bx = x + w - Math.min(w * 0.3, 26), r1 = Math.min(h, w) * 0.13;
        s += '<circle cx="' + bx + '" cy="' + (y + h * 0.32) + '" r="' + r1 + '" fill="none" stroke="' + TEAL + '" stroke-width="1.1"/><circle cx="' + bx + '" cy="' + (y + h * 0.68) + '" r="' + r1 + '" fill="none" stroke="' + TEAL + '" stroke-width="1.1"/>';
        r = { x: r.x, y: r.y, w: r.w, h: r.h, label: '', style: st };
      } else {
        s += '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="2" fill="' + f + '"' + stroke + '>' + title + '</rect>';
      }
      if (r.label) {
        var tx = x + w / 2, ty = y + h / 2, rot = h > w * 1.4;
        var bg = (st === 'plan' || st === 'cuisine') ? '#EADCBF' : (st === 'table' ? '#fff' : (st === 'assise' || st === 'couchage') ? (cush || SEAT) : st === 'dossier' ? (cush || SEAT_D) : f);
        var dark = DARK.indexOf(bg) !== -1 || ['#4A4D50', '#3E5C7A', '#5B7377', SEAT_D].indexOf(bg) !== -1;
        s += '<text x="' + tx + '" y="' + ty + '" text-anchor="middle" dominant-baseline="middle" font-size="8" font-weight="600" fill="' + (dark ? '#fff' : TEAL) + '"' + (rot ? ' transform="rotate(-90 ' + tx + ' ' + ty + ')"' : '') + '>' + esc(r.label) + '</text>';
      }
      return s;
    }

    function renderPlan() {
      var night = state.mode === 'nuit';
      var L = V.length, W = V.width, cab = V.deepCab ? 197 : 92, padX = 34, padTop = 40, padBot = 36;
      var ox = padX + cab, oy = padTop, vbW = ox + L + 70, vbH = padTop + W + padBot;
      var df = V.doorFrom, dt = V.doorTo, wf = V.wheelFrom, wt = V.wheelTo, wd = V.wheelDepth;
      var floor = habOn('floor'), walls = habOn('walls');
      var s = '<svg viewBox="0 0 ' + vbW + ' ' + vbH + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + esc('Plan vu de dessus' + (night ? ', mode nuit' : '') + ' : ' + selected().map(function (m) { return m.name; }).concat(selectedHabs().map(function (h) { return h.name; })).join(', ')) + '" font-family="inherit">';
      s += '<defs>' +
        '<pattern id="' + uid + '-g" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M10 0H0V10" fill="none" stroke="#E9F0F0" stroke-width=".6"/></pattern>' +
        '<pattern id="' + uid + '-h" width="5" height="5" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="5" stroke="#7D8F92" stroke-width="1.2"/></pattern>' +
        '<pattern id="' + uid + '-f" width="40" height="12" patternUnits="userSpaceOnUse"><rect width="40" height="12" fill="#F3E7CF"/><path d="M0 12H40M20 0V12" stroke="#E2CFA8" stroke-width=".7"/></pattern>' +
        '</defs>';
      if (night) s += '<rect x="0" y="0" width="' + vbW + '" height="' + vbH + '" fill="#EEF2F6"/>';

      var cx0 = ox - cab;
      s += '<path d="M' + ox + ' ' + (oy - 3) + ' L' + (cx0 + 30) + ' ' + (oy + 2) + ' Q' + cx0 + ' ' + (oy + 8) + ' ' + cx0 + ' ' + (oy + 40) + ' L' + cx0 + ' ' + (oy + W - 40) + ' Q' + cx0 + ' ' + (oy + W - 8) + ' ' + (cx0 + 30) + ' ' + (oy + W - 2) + ' L' + ox + ' ' + (oy + W + 3) + ' Z" fill="#EEF4F4" stroke="' + TEAL + '" stroke-width="1.5"/>';
      s += '<path d="M' + (cx0 + 10) + ' ' + (oy + 30) + ' Q' + (cx0 + 4) + ' ' + (oy + W / 2) + ' ' + (cx0 + 10) + ' ' + (oy + W - 30) + '" fill="none" stroke="#9FC4C9" stroke-width="3" stroke-linecap="round"/>';
      var sx = cx0 + 36, sw = 40;
      s += '<g fill="#DDE8E9" stroke="' + TEAL + '" stroke-width="1.1">' +
        '<rect x="' + sx + '" y="' + (oy + 10) + '" width="' + sw + '" height="82" rx="7"><title>Banquette passager 2 places</title></rect>' +
        '<line x1="' + sx + '" y1="' + (oy + 51) + '" x2="' + (sx + sw) + '" y2="' + (oy + 51) + '"/>' +
        '<rect x="' + (sx + sw - 9) + '" y="' + (oy + 10) + '" width="9" height="82" rx="3"/>' +
        '<rect x="' + sx + '" y="' + (oy + W - 56) + '" width="' + sw + '" height="46" rx="7"><title>Siège conducteur</title></rect>' +
        '<rect x="' + (sx + sw - 9) + '" y="' + (oy + W - 56) + '" width="9" height="46" rx="3"/>' +
        '</g>';
      s += '<circle cx="' + (cx0 + 22) + '" cy="' + (oy + W - 33) + '" r="11" fill="none" stroke="' + TEAL + '" stroke-width="1.6"><title>Volant</title></circle>';
      var fd = V.deepCab ? cx0 + 90 : ox;
      [oy - 1, oy + W + 1].forEach(function (y, i) {
        var y2 = i === 0 ? y - 12 : y + 12;
        s += '<line x1="' + (cx0 + 34) + '" y1="' + y + '" x2="' + (fd - 4) + '" y2="' + y + '" stroke="#FCFCF7" stroke-width="4"/>' +
          '<path d="M' + (cx0 + 34) + ' ' + y + ' L' + (fd - 10) + ' ' + y2 + '" stroke="' + TEAL + '" stroke-width="1.4"/>' +
          '<path d="M' + (fd - 4) + ' ' + y + ' Q' + (fd - 4) + ' ' + y2 + ' ' + (fd - 10) + ' ' + y2 + '" fill="none" stroke="' + TEAL + '" stroke-width=".8" stroke-dasharray="2 2"/>';
      });
      if (V.deepCab) { /* cabine approfondie : 2e rang, porte coulissante en cabine, cloison */
        s += '<rect x="' + (cx0 + 140) + '" y="' + (oy + 8) + '" width="38" height="' + (W - 16) + '" rx="7" fill="#DDE8E9" stroke="' + TEAL + '" stroke-width="1.1"><title>Banquette 2e rang</title></rect>' +
          '<rect x="' + (cx0 + 169) + '" y="' + (oy + 8) + '" width="9" height="' + (W - 16) + '" rx="3" fill="#DDE8E9" stroke="' + TEAL + '" stroke-width="1.1"/>';
        s += '<line x1="' + (cx0 + 92) + '" y1="' + (oy - 1) + '" x2="' + (ox - 4) + '" y2="' + (oy - 1) + '" stroke="#FCFCF7" stroke-width="4"/>' +
          '<line x1="' + (cx0 + 92) + '" y1="' + (oy - 6) + '" x2="' + (ox + 10) + '" y2="' + (oy - 6) + '" stroke="' + TEAL + '" stroke-width="1.6"/>' +
          '<path d="M' + (ox + 4) + ' ' + (oy - 9) + ' L' + (ox + 10) + ' ' + (oy - 6) + ' L' + (ox + 4) + ' ' + (oy - 3) + '" fill="none" stroke="' + TEAL + '" stroke-width="1.2"/>';
        s += '<text x="' + (cx0 + 150) + '" y="' + (oy - 14) + '" text-anchor="middle" font-size="7.5" fill="' + TEAL + '">Porte latérale</text>';
        s += '<text x="' + (cx0 + 150) + '" y="' + (oy + W + 14) + '" text-anchor="middle" font-size="7.5" fill="' + TEAL + '">2e rang</text>';
      }
      s += '<text x="' + (cx0 + 60) + '" y="' + (oy - 18) + '" text-anchor="middle" font-size="7.5" fill="' + TEAL + '">Porte passager</text>';
      s += '<text x="' + (cx0 + 60) + '" y="' + (oy + W + 24) + '" text-anchor="middle" font-size="7.5" fill="' + TEAL + '">Porte conducteur</text>';

      s += '<rect x="' + ox + '" y="' + oy + '" width="' + L + '" height="' + W + '" fill="' + (floor ? 'url(#' + uid + '-f)' : '#fff') + '"/>';
      if (!floor) s += '<rect x="' + ox + '" y="' + oy + '" width="' + L + '" height="' + W + '" fill="url(#' + uid + '-g)"/>';
      s += '<rect x="' + ox + '" y="' + oy + '" width="' + L + '" height="' + W + '" fill="none" stroke="' + TEAL + '" stroke-width="2"/>';
      if (walls) {
        s += '<g stroke="#B98F55" stroke-width="3.2">' +
          '<line x1="' + ox + '" y1="' + (oy + 2.5) + '" x2="' + (ox + df) + '" y2="' + (oy + 2.5) + '"/>' +
          '<line x1="' + (ox + dt) + '" y1="' + (oy + 2.5) + '" x2="' + (ox + L) + '" y2="' + (oy + 2.5) + '"/>' +
          '<line x1="' + ox + '" y1="' + (oy + W - 2.5) + '" x2="' + (ox + L) + '" y2="' + (oy + W - 2.5) + '"/>' +
          '</g>';
      }
      if (dt > df) {
        s += '<line x1="' + (ox + df) + '" y1="' + oy + '" x2="' + (ox + dt) + '" y2="' + oy + '" stroke="#FCFCF7" stroke-width="5"/>';
        s += '<line x1="' + (ox + df) + '" y1="' + (oy - 6) + '" x2="' + (ox + dt + 55) + '" y2="' + (oy - 6) + '" stroke="' + TEAL + '" stroke-width="1.6"/>';
        s += '<path d="M' + (ox + dt + 49) + ' ' + (oy - 9) + ' L' + (ox + dt + 55) + ' ' + (oy - 6) + ' L' + (ox + dt + 49) + ' ' + (oy - 3) + '" fill="none" stroke="' + TEAL + '" stroke-width="1.2"/>';
        s += '<text x="' + (ox + (df + dt) / 2) + '" y="' + (oy - 14) + '" text-anchor="middle" font-size="8" fill="' + TEAL + '">Porte latérale coulissante</text>';
      }
      if (V.deepCab) s += '<line x1="' + ox + '" y1="' + oy + '" x2="' + ox + '" y2="' + (oy + W) + '" stroke="' + TEAL + '" stroke-width="4"><title>Cloison</title></line><text x="' + (ox + 4) + '" y="' + (oy + W + 14) + '" font-size="7.5" fill="' + TEAL + '">Cloison</text>';
      var ry = oy + 5, rh = W - 10, leaf = rh / 2;
      s += '<line x1="' + (ox + L) + '" y1="' + ry + '" x2="' + (ox + L) + '" y2="' + (ry + rh) + '" stroke="#FCFCF7" stroke-width="5"/>';
      s += '<g stroke="' + TEAL + '" fill="none">' +
        '<line x1="' + (ox + L) + '" y1="' + ry + '" x2="' + (ox + L + 30) + '" y2="' + (ry + 14) + '" stroke-width="1.6"/>' +
        '<line x1="' + (ox + L) + '" y1="' + (ry + rh) + '" x2="' + (ox + L + 30) + '" y2="' + (ry + rh - 14) + '" stroke-width="1.6"/>' +
        '<path d="M' + (ox + L) + ' ' + (ry + leaf) + ' A ' + leaf + ' ' + leaf + ' 0 0 0 ' + (ox + L + 30) + ' ' + (ry + 14) + '" stroke-width=".8" stroke-dasharray="2 2"/>' +
        '<path d="M' + (ox + L) + ' ' + (ry + leaf) + ' A ' + leaf + ' ' + leaf + ' 0 0 1 ' + (ox + L + 30) + ' ' + (ry + rh - 14) + '" stroke-width=".8" stroke-dasharray="2 2"/>' +
        '</g>';
      s += '<text x="' + (ox + L + 52) + '" y="' + (oy + W / 2) + '" text-anchor="middle" font-size="8" fill="' + TEAL + '" transform="rotate(90 ' + (ox + L + 52) + ' ' + (oy + W / 2) + ')">Portes arrière 2 battants</text>';

      if (wt > wf && wd > 0) {
        [oy, oy + W - wd].forEach(function (y) {
          s += '<rect x="' + (ox + wf) + '" y="' + y + '" width="' + (wt - wf) + '" height="' + wd + '" rx="' + Math.min(10, wd / 2) + '" fill="url(#' + uid + '-h)" fill-opacity=".55" stroke="#5D7275" stroke-width="1" stroke-dasharray="3 2"><title>Passage de roue</title></rect>';
        });
      }
      /* meubles : d'abord les couchages et assises, puis le reste par-dessus */
      var list = [];
      selected().forEach(function (m) {
        var rects = night && m.nightList.length ? m.nightList : m.dayList;
        rects.forEach(function (r) { if (night && r.style === 'table') return; list.push({ m: m, r: r }); });
      });
      var rank = { couchage: 0, assise: 1, dossier: 2 };
      list.sort(function (a, b) { return (rank[a.r.style] != null ? rank[a.r.style] : 3) - (rank[b.r.style] != null ? rank[b.r.style] : 3); });
      list.forEach(function (it) { s += shape(it.m, it.r, ox, oy, colorIn(SWATCH, finOf(it.m), '#E6D2AC'), cushColor(it.m), it.m.soon); });
      if (!night) selected().forEach(function (m) {
        var sg = suggestionOf(m); if (!sg || !m.suggestList.length) return;
        s += '<g class="exo-am__ghost" opacity=".45" data-suggest-zone="' + esc(zoneOf[sg.key].id) + '" data-suggest-key="' + esc(sg.key) + '" style="cursor:pointer">';
        m.suggestList.forEach(function (r) { s += shape({ name: sg.name + ' (suggéré)', extern: 'possible, non sélectionné' }, r, ox, oy, '#F4F1EA', null, true); });
        s += '</g>';
      });

      if (wt > wf && wd > 0) s += '<text x="' + (ox + (wf + wt) / 2) + '" y="' + (oy + W + 24) + '" text-anchor="middle" font-size="7.5" fill="#5D7275">Passages de roue</text>';
      s += '<text x="' + (ox + 8) + '" y="' + (oy + W + 24) + '" text-anchor="start" font-size="7.5" fill="#5D7275">Côté conducteur</text>';
      planEl.innerHTML = s + '</svg>';

      var lg = ['<li><i class="exo-am__lg-seat"></i>Banquette / couchage</li>', '<li><i class="exo-am__lg-wood"></i>Meubles et rangements</li>', '<li><i class="exo-am__lg-hatch"></i>Passage de roue</li>'];
      selected().forEach(function (m) {
        lg.push('<li><i style="background:' + (m.soon ? '#F4F1EA;border-style:dashed' : colorIn(SWATCH, finOf(m), '#E6D2AC')) + '"></i>' + esc(m.name) + (m.soon ? ' · ' + esc(m.extern ? 'non fournie' : 'bientôt') : ' · ' + esc(shortFinish(finOf(m)))) + (night && m.couchage ? ' · lit ' + esc(m.couchage) : '') + '</li>');
      });
      selectedHabs().forEach(function (h) {
        var sw = h.key === 'floor' ? '<i class="exo-am__lg-floor"></i>' : h.key === 'walls' ? '<i class="exo-am__lg-wall"></i>' : '<i class="exo-am__lg-ceil"></i>';
        lg.push('<li>' + sw + esc(h.name) + (h.key === 'ceiling' ? ' (non visible en vue de dessus)' : '') + '</li>');
      });
      if (legendEl) legendEl.innerHTML = lg.join('');
      if (modeEl) {
        modeEl.hidden = !hasNight();
        modeEl.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-set-mode') === state.mode)); });
      }
    }
    planEl.addEventListener('click', function (e) { var g = e.target.closest('[data-suggest-key]'); if (g) choose(g.getAttribute('data-suggest-zone'), g.getAttribute('data-suggest-key')); });
    if (modeEl) modeEl.addEventListener('click', function (e) { var b = e.target.closest('[data-set-mode]'); if (!b) return; state.mode = b.getAttribute('data-set-mode'); renderPlan(); });

    /* ----- récapitulatif ----- */
    var linesEl = root.querySelector('[data-lines]'), totalEl = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]'), barBtn = root.querySelector('[data-add-bar]');
    var barTotal = root.querySelector('[data-bar-total]'), barNote = root.querySelector('[data-bar-note]');
    function cushVariant(m) { var c = state.cush[m.key]; return m.cushion && typeof c === 'number' ? m.cushion.variants.filter(function (v) { return v.id === c; })[0] : null; }
    function missing() {
      var out = [];
      selected().forEach(function (m) {
        if (m.cushion && state.cush[m.key] == null) out.push('Coussins : ' + m.name);
        if (m.product) out = out.concat(gpoMissing(m.product, m.name));
      });
      selectedHabs().forEach(function (h) { out = out.concat(gpoMissing(h.product, h.name)); });
      return out;
    }
    function sellable() { return selected().some(function (m) { return !m.soon; }) || selectedHabs().length > 0; }
    function line(img, name, detail, price, muted) {
      return '<div class="exo-am__line' + (muted ? ' exo-am__line--soon' : '') + '"><span class="exo-am__line-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="72">' : '') + '</span><span class="exo-am__line-txt"><b>' + esc(name) + '</b><small>' + esc(detail) + '</small></span><span class="exo-am__line-price">' + price + '</span></div>';
    }
    function renderSummary() {
      var total = 0, html = '';
      selected().forEach(function (m) {
        if (m.soon) { html += line(null, m.name, (m.extern || 'Bientôt disponible') + ' · non ajouté au panier', '—', true); return; }
        var v = variantFor(m), p = itemPrice(m); total += p;
        var det = [m.note ? 'Position : ' + m.note : '', v.title !== 'Default Title' ? shortFinish(v.title) : '', v.sku ? 'Réf. ' + v.sku : '', gpoSummary(m.product)].filter(Boolean).join(' · ');
        html += line(imgFor(m), m.name, det, money(p));
        var cv = cushVariant(m);
        if (cv) { total += cv.price; html += line(m.cushion.image, 'Coussins · ' + m.name, cv.title + (cv.sku ? ' · Réf. ' + cv.sku : ''), money(cv.price)); }
      });
      selectedHabs().forEach(function (h) {
        var v = h.product.variants[0], p = habPrice(h); total += p;
        html += line(v.img || h.product.image, h.name, [v.sku ? 'Réf. ' + v.sku : '', gpoSummary(h.product)].filter(Boolean).join(' · '), money(p));
      });
      linesEl.innerHTML = html;
      totalEl.textContent = money(total); barTotal.textContent = money(total);
      var miss = missing(), ok = sellable() && !miss.length;
      addBtn.disabled = !ok; barBtn.disabled = false;
      addBtn.textContent = ok ? "Ajouter l'aménagement au panier" : (!sellable() ? 'Choisissez au moins un produit disponible' : 'À préciser : ' + miss[0]);
      barBtn.textContent = ok ? 'Ajouter au panier' : 'Compléter';
      barNote.textContent = miss.length ? miss.length + ' choix à préciser' : '';
    }

    function render() { renderSteps(); renderPlan(); renderSummary(); }

    /* ----- panier ----- */
    var msg = root.querySelector('[data-msg]');
    function pushWithGpo(items, product, variantId, props, n) {
      var s = gpoState(product), addons = [];
      if (s) {
        var group = String(Date.now()) + String(n);
        var any = false;
        s.g.elements.forEach(function (e) {
          var i = s.st[e.id]; if (i == null) return;
          var v = e.values[i]; any = true; props[e.cart] = v.value;
          if (v.variant) addons.push({ id: Number(v.variant), quantity: 1, properties: { _gpo_parent_product_group: group, _gpo_field_name: e.cart } });
        });
        if (any) { props._has_gpo = s.g.setId; props._gpo_product_group = group; }
      }
      addons.forEach(function (a) { items.push(a); });
      items.push({ id: variantId, quantity: 1, properties: props });
    }
    function newRef() { return 'CFG-' + Date.now().toString(36).toUpperCase().slice(-6); }
    function buildItems(ref) {
      var label = ref + ' · ' + [cfg.amenagement, cfg.vehicleName].filter(Boolean).join(' · ');
      var base = function () { return { 'Configuration': label, '_configurateur': 'exokit-v3' }; };
      var items = [], n = 0;
      selected().forEach(function (m) {
        if (m.soon) return;
        var props = base(), f = finishLabel(finOf(m));
        if (f.tint) props['Teinte'] = f.family + ' ' + f.tint;
        if (m.note) props['Position'] = m.note;
        pushWithGpo(items, m.product, variantFor(m).id, props, n++);
        var cv = cushVariant(m);
        if (cv) { var cp = base(); cp['Pour'] = m.name; items.push({ id: cv.id, quantity: 1, properties: cp }); }
      });
      selectedHabs().forEach(function (h) { pushWithGpo(items, h.product, h.product.variants[0].id, base(), n++); });
      return items;
    }
    function addToCart(ref) {
      if (addBtn.disabled) return;
      var items = buildItems(typeof ref === 'string' ? ref : newRef());
      addBtn.disabled = barBtn.disabled = true; msg.textContent = 'Ajout en cours…';
      fetch(cfg.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); })
        .then(function () { msg.textContent = 'Aménagement ajouté. Redirection vers le panier…'; window.location.href = cfg.cartUrl; })
        .catch(function (e) { msg.textContent = "Impossible d'ajouter au panier : " + e.message; renderSummary(); });
    }
    addBtn.addEventListener('click', function () { addToCart(); });
    barBtn.addEventListener('click', function () {
      if (!addBtn.disabled) addToCart();
      else { var t = stepsEl.querySelector('.exo-am__gpo-label em, .exo-am__cush') || root.querySelector('.exo-am__recap'); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });

    /* ----- devis par e-mail ----- */
    var qOpen = root.querySelector('[data-quote-open]'), qDlg = root.querySelector('[data-quote-dlg]');
    if (qOpen && qDlg) (function () {
      var Q = cfg.quote || {};
      var qForm = qDlg.querySelector('[data-quote-form]'), qDone = qDlg.querySelector('[data-quote-done]');
      var qErr = qDlg.querySelector('[data-quote-err]'), qSub = qDlg.querySelector('[data-quote-submit]'), qSum = qDlg.querySelector('[data-quote-sum]');
      var qCart = qDlg.querySelector('[data-quote-cart]'), subLabel = qSub.textContent, lastRef = null;
      var EMAIL = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
      function eur(c) { return Math.round(c) / 100; }
      function rows() {
        var out = [], total = 0;
        selected().forEach(function (m) {
          if (m.soon) { out.push({ libelle: m.name, detail: (m.extern || 'Bientôt disponible') + ' (non inclus dans le devis)', prix: null }); return; }
          var v = variantFor(m), p = itemPrice(m); total += p;
          out.push({ libelle: m.name, detail: [m.note ? 'Position : ' + m.note : '', v.title !== 'Default Title' ? shortFinish(v.title) : '', v.sku ? 'Réf. ' + v.sku : '', gpoSummary(m.product)].filter(Boolean).join(' · '), prix: p });
          var cv = cushVariant(m);
          if (cv) { total += cv.price; out.push({ libelle: 'Coussins · ' + m.name, detail: [cv.title, cv.sku ? 'Réf. ' + cv.sku : ''].filter(Boolean).join(' · '), prix: cv.price }); }
        });
        selectedHabs().forEach(function (h) {
          var v = h.product.variants[0], p = habPrice(h); total += p;
          out.push({ libelle: h.name, detail: [v.sku ? 'Réf. ' + v.sku : '', gpoSummary(h.product)].filter(Boolean).join(' · '), prix: p });
        });
        return { rows: out, total: total };
      }
      function permalink(items) {
        var q = {}, order = [];
        items.forEach(function (i) { if (!q[i.id]) { q[i.id] = 0; order.push(i.id); } q[i.id] += i.quantity; });
        return order.length ? window.location.origin + '/cart/' + order.map(function (id) { return id + ':' + q[id]; }).join(',') : '';
      }
      function paintSum() {
        var r = rows(), miss = missing();
        qSum.innerHTML = '<b>' + esc([cfg.amenagement, cfg.vehicleName].filter(Boolean).join(' · ')) + '</b>' +
          '<span>' + r.rows.filter(function (x) { return x.prix != null; }).length + ' article(s) · ' + esc(money(r.total)) + ' TTC</span>' +
          (miss.length ? '<small>À préciser ensemble : ' + esc(miss.join(', ')) + '</small>' : '');
      }
      function open() {
        paintSum(); qErr.textContent = ''; qForm.hidden = false; qDone.hidden = true;
        qSub.disabled = false; qSub.textContent = subLabel;
        if (qDlg.showModal) qDlg.showModal(); else qDlg.setAttribute('open', '');
        var f = qForm.querySelector('input[name=prenom]'); if (f) setTimeout(function () { f.focus(); }, 30);
      }
      function close() { if (qDlg.close) qDlg.close(); else qDlg.removeAttribute('open'); }
      qOpen.addEventListener('click', open);
      qDlg.addEventListener('click', function (e) { if (e.target === qDlg || e.target.closest('[data-quote-close]')) close(); });
      qCart.addEventListener('click', function () { close(); addToCart(lastRef || undefined); });

      function val(n) { var el = qForm.elements[n]; return el ? String(el.value || '').trim() : ''; }
      function postWebhook(body) {
        if (!Q.webhook) return Promise.resolve('none');
        return fetch(Q.webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
          .then(function (r) { if (!r.ok) throw new Error('webhook ' + r.status); return 'sent'; })
          .catch(function () {
            return fetch(Q.webhook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body })
              .then(function () { return 'sent'; }, function () { return 'fail'; });
          });
      }
      function postContact(d, recap) {
        var f = Q.form && document.getElementById(Q.form);
        if (!f) return Promise.resolve('none');
        f.elements['contact[name]'].value = [d.client.prenom, d.client.nom].filter(Boolean).join(' ');
        f.elements['contact[email]'].value = d.client.email;
        f.elements['contact[phone]'].value = d.client.telephone;
        f.elements['contact[Sujet]'].value = 'Devis configurateur ' + d.ref + ' · ' + [d.amenagement.nom, d.vehicule.nom].filter(Boolean).join(' · ');
        f.elements['contact[body]'].value = recap;
        return fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' })
          .then(function (r) { if (/challenge/.test(r.url)) return 'challenge'; if (!r.ok) throw new Error('contact ' + r.status); return 'sent'; })
          .catch(function () { return 'fail'; });
      }

      qForm.addEventListener('submit', function (e) {
        e.preventDefault();
        qErr.textContent = '';
        if (val('site_web')) { qForm.hidden = true; qDone.hidden = false; return; }
        if (val('prenom').length < 2) { qErr.textContent = 'Merci d\'indiquer votre prénom.'; qForm.elements.prenom.focus(); return; }
        if (!EMAIL.test(val('email'))) { qErr.textContent = 'Merci d\'indiquer une adresse e-mail valide.'; qForm.elements.email.focus(); return; }

        var ref = newRef(), items = buildItems(ref), r = rows(), miss = missing();
        var title = [cfg.amenagement, cfg.vehicleName].filter(Boolean).join(' · ');
        var client = { prenom: val('prenom'), nom: val('nom'), email: val('email'), telephone: val('telephone'), code_postal: val('code_postal'), message: val('message'), newsletter: !!(qForm.elements.optin && qForm.elements.optin.checked) };
        var cart = permalink(items);
        var recap = ['Devis ' + ref + ' : ' + title, ''].concat(r.rows.map(function (x) {
          return '• ' + x.libelle + (x.detail ? ' (' + x.detail + ')' : '') + ' : ' + (x.prix != null ? money(x.prix) : '—');
        })).concat(['', 'Total TTC : ' + money(r.total) + ' (livraison calculée au panier)',
          miss.length ? 'À préciser : ' + miss.join(', ') : '',
          cart ? 'Commander cette configuration : ' + cart : '', 'Page : ' + window.location.href, '',
          'Client : ' + [client.prenom, client.nom].filter(Boolean).join(' ') + ' · ' + client.email + (client.telephone ? ' · ' + client.telephone : '') + (client.code_postal ? ' · ' + client.code_postal : ''),
          'Newsletter : ' + (client.newsletter ? 'oui' : 'non'),
          client.message ? 'Message : ' + client.message : '']).filter(function (l, i, a) { return l !== '' || (a[i - 1] !== ''); }).join('\n');
        var lineItems = items.map(function (i) {
          return { variantId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity,
            customAttributes: Object.keys(i.properties || {}).filter(function (k) { return k.charAt(0) !== '_'; }).map(function (k) { return { key: k, value: String(i.properties[k]) }; }) };
        });
        var d = {
          type: 'devis_configurateur', version: 1, ref: ref, date_envoi: new Date().toISOString(),
          page_url: window.location.href, page_titre: document.title,
          vehicule: { nom: cfg.vehicleName || '', handle: cfg.vehicleHandle || '' },
          amenagement: { nom: cfg.amenagement || '', handle: cfg.amenagementHandle || '' },
          client: client,
          lignes: r.rows.map(function (x) { return { libelle: x.libelle, detail: x.detail, prix_ttc: x.prix != null ? eur(x.prix) : null, prix_texte: x.prix != null ? money(x.prix) : 'non inclus' }; }),
          a_preciser: miss, total_ttc: eur(r.total), total_texte: money(r.total),
          devise: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
          lien_panier: cart, recap_texte: recap,
          draft_order: lineItems.length ? {
            email: client.email,
            note: recap,
            tags: ['devis-configurateur', 'cfg-' + (cfg.vehicleHandle || 'vehicule')],
            customAttributes: [{ key: 'Référence devis', value: ref }, { key: 'Configuration', value: title }, { key: 'Page', value: window.location.href }],
            lineItems: lineItems
          } : null,
          email_devis: {
            to: client.email,
            subject: 'Votre devis Exokit ' + ref + ' · ' + title,
            customMessage: 'Bonjour ' + client.prenom + ',\n\nVoici le devis de l\'aménagement que vous avez configuré sur exokit-van.com : ' + title + '.' +
              (miss.length ? '\nÀ préciser ensemble : ' + miss.join(', ') + '.' : '') +
              '\n\nLe bouton ci-dessous vous permet de le commander tel quel. Une question ? Répondez simplement à cet e-mail.\n\nL\'équipe Exokit'
          }
        };
        var body = JSON.stringify(d);
        qSub.disabled = true; qSub.textContent = 'Envoi en cours…';
        postWebhook(body).then(function (w) {
          var needCopy = Q.copy || w !== 'sent';
          return (needCopy ? postContact(d, recap) : Promise.resolve('skip')).then(function (c) { return { w: w, c: c }; });
        }).then(function (res) {
          if (res.w !== 'sent' && res.c === 'challenge') { /* l'anti-spam Shopify demande une vérification : envoi classique */
            var f = document.getElementById(Q.form); if (f) { f.submit(); return; }
          }
          if (res.w !== 'sent' && res.c !== 'sent') throw new Error('envoi');
          lastRef = ref;
          var txt = (res.w === 'sent' ? Q.doneSent : Q.doneLater) || '';
          qDlg.querySelector('[data-quote-done-text]').textContent = txt.replace(/\{email\}/g, client.email);
          qDlg.querySelector('[data-quote-ref]').textContent = 'Référence : ' + ref;
          qCart.hidden = addBtn.disabled;
          qForm.hidden = true; qDone.hidden = false;
          var h = qDone.querySelector('h2'); if (h) h.focus();
          try { if (Q.gads && typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: Q.gads, value: eur(r.total), currency: d.devise }); } catch (x) {}
          try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { value: eur(r.total), currency: d.devise, lead_source: 'configurateur' }); } catch (x) {}
          try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('exo_devis_envoye', { ref: ref, total: eur(r.total), vehicule: d.vehicule.handle, amenagement: d.amenagement.handle }); } catch (x) {}
        }).catch(function () {
          qErr.innerHTML = 'L\'envoi n\'a pas abouti. Réessayez dans un instant, ou <a href="' + esc(cfg.contactUrl) + '">écrivez-nous</a>.';
          qSub.disabled = false; qSub.textContent = subLabel;
        });
      });
    })();

    render();
  }

  function boot() { document.querySelectorAll('.exo-am[data-v3]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();